import "./src/scss/index.scss";

export const onRouteUpdate = () => {
  document.getElementsByTagName("body")[0]?.classList.remove("nav-expanded");
  document
    .getElementsByTagName("body")[0]
    ?.classList.remove("sub-nav-expanded");

  const scrollToTopRoutes = ["/latest"];
  const paginationRouteHashes = [
    "#postcards-pagination-top",
    "#postcards-pagination-bottom",
  ];
  const { pathname, hash } = window.location;

  if (
    !paginationRouteHashes.includes(hash) &&
    scrollToTopRoutes.some((route) => pathname.includes(route))
  ) {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }, 1);
  }
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const paginationRouteHashes = [
    "#postcards-pagination-top",
    "#postcards-pagination-bottom",
  ];

  if (paginationRouteHashes.includes(location.hash)) {
    return false;
  }

  return [0, 0];
};
